export default __webpack_public_path__ + "static/media/plain-sticker-b.ff5e0b3a.png";